import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetWorkflowDefinitionRequest, IRejectWithValue, PhpResponse, Workflow } from "../../../types";
import { phpClient } from "../../../network";

export const getWorkflowDefinition = createAsyncThunk<Workflow[], GetWorkflowDefinitionRequest, IRejectWithValue>(
    "workflow/getWorkflowDefinition",
    async (data, { rejectWithValue }) => {
        try {
            const response = await phpClient.post<PhpResponse<Workflow[]>>({
                url: "/workflow/get_definition",
                data,
            });
            
            return response.data ?? [];
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);
